import { createSlice } from '@reduxjs/toolkit';
import { 
  addComment, 
  fetchCommentsByProduct 
} from '../../services';
import { 
  Comment, 
  CommentItem, 
  CommentsState 
} from '../../components/interfaces';

const initialState: CommentsState = {
  comments: [],
  status: 'idle',
  error: null,
};

const commentsSlice = createSlice({
  name: 'comments',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCommentsByProduct.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchCommentsByProduct.fulfilled, (state, action) => {
        state.comments = action.payload as unknown as Comment[];
        state.status = 'succeeded';
      })
      .addCase(fetchCommentsByProduct.rejected, (state, action) => {
        state.error = action.error.message || 'Failed to fetch comments';
        state.status = 'failed';
      })
      .addCase(addComment.fulfilled, (state, action) => {
        const newCommentItem = action.payload as CommentItem & { comment?: { id: string } };
        const commentId = newCommentItem.commentId || newCommentItem.comment?.id;
        const existingComment = state.comments.find(comment => comment.id === commentId);
        if (existingComment) {
          existingComment.commentItems.push(newCommentItem);
        } else if (commentId) {
          state.comments.push({
            id: commentId,
            commentItems: [newCommentItem],
            author: newCommentItem.author,
            createdAt: newCommentItem.createdAt,
            productId: newCommentItem.productId,
          });
        }
        state.status = 'succeeded';
      })
      .addCase(addComment.rejected, (state, action) => {
        state.error = action.payload as string;
        state.status = 'failed';
      });
  },
});

export default commentsSlice.reducer;

